module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="b-search-email-row">\n	<div class="b-search-email">\n\n	</div>\n</div>\n\n';

}
return __p
}